import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
  FormGroup,
  Spinner,
} from 'reactstrap';

interface RequestAccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (note: string) => Promise<void>;
  trackName: string;
  sourceOrgName?: string;
}

const RequestAccessModal: React.FC<RequestAccessModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  trackName,
  sourceOrgName,
}) => {
  const [note, setNote] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await onSubmit(note);
      setNote('');
    } catch (err) {
      console.error('Error submitting access request:', err);
    }
    setSubmitting(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      contentClassName="delete-confirm-modal"
      style={{ color: '#ffffff' }}
    >
      <ModalHeader
        toggle={onClose}
        style={{
          backgroundColor: 'var(--chatbot-color-2)',
          color: '#ffffff',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      >
        <span style={{ color: '#fff' }}>Request Access</span>
      </ModalHeader>
      <ModalBody style={{ backgroundColor: 'var(--chatbot-color-1)', color: '#ffffff', padding: '1.5rem' }}>
        <p style={{ marginBottom: '1rem', color: 'rgba(255, 255, 255, 0.8)' }}>
          Request access to <strong>{trackName}</strong>
          {sourceOrgName ? <> from <strong>{sourceOrgName}</strong></> : null}.
        </p>
        <p style={{ marginBottom: '1rem', fontSize: '0.85rem', color: 'rgba(255, 255, 255, 0.5)' }}>
          The owner will be notified of your request and can approve or deny it. If approved, the track will be added to your library.
        </p>
        <FormGroup>
          <Label for="access-request-note" style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.85rem' }}>
            Message (optional)
          </Label>
          <Input
            id="access-request-note"
            type="textarea"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Add a note for the owner..."
            rows={3}
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              color: '#fff',
              border: '1px solid rgba(255, 255, 255, 0.15)',
            }}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter
        style={{
          backgroundColor: 'var(--chatbot-color-2)',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          padding: '1rem 1.5rem',
          gap: '0.75rem',
        }}
      >
        <Button className="btn-info-custom" onClick={onClose} disabled={submitting}>
          <span style={{ position: 'relative', zIndex: 2 }}>Cancel</span>
        </Button>
        <Button className="btn-primary-custom" onClick={handleSubmit} disabled={submitting}>
          <span style={{ position: 'relative', zIndex: 2 }}>
            {submitting ? <><Spinner size="sm" className="mr-1" /> Sending...</> : 'Send Request'}
          </span>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RequestAccessModal;
